<template>
  <b-row no-gutters>
    <b-modal
      id="modal-leave"
      ref="leaveModal"
      :hide-header="true"
      :hide-footer="true"
      :cancel-disabled="true"
      content-class="blah"
      dialog-class="leave-meeting-wrapper"
      body-class="leave-meeting-body"
    >
      <div class="leave-meeting flex-row d-flex rounded">
        <div class="content rounded">
          <b-container
            fluid
            class="p-0">
            <b-row no-gutters>
              <span class="title">{{ $t('MEETING.LEAVE_MEETING') }}</span>
            </b-row>
            <b-row no-gutters>
              <span class="description">{{ $t('MEETING.POPUP_LEAVE_ROOM_CONFIRMATION') }}</span>
            </b-row>
            <b-row no-gutters>
              <div>
                <div class="form-group light">
                  <b-form-checkbox-group
                    v-model="settings"
                    :options="generalOptions"
                    class="form-control-light"
                    @change="updateSetting(generalOptions)"/>
                </div>
              </div>
              <b-col align="right">
                <b-btn
                  size="sm"
                  variant="secondary-light"
                  @click="$refs.leaveModal.hide()">
                  {{ $t('MEETING.POPUP_NO') }}
                </b-btn>
                <b-btn
                  size="sm"
                  variant="primary-light"
                  @click="$parent.exitMeeting()">
                  {{ $t('MEETING.POPUP_YES') }}
                </b-btn>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </b-modal>
  </b-row>
</template>

<script>
import {ref} from "@vue/composition-api"
import {loadStorageData, getItem, setItem} from "../functions/storageManager"

export default {
  name: 'LeaveMeeting',
  setup(props, context) {
    loadStorageData()
    const settings = ref([])

    const generalOptions = ref([
      {text: context.root.$t("MEETING.POPUP_ASK_TO_CONFIRM"), value: 'confirmLeave'},
    ])
    load()
    //default set to true
    if (typeof getItem('confirmLeave') === 'undefined' ) {
      settings.value.push('confirmLeave')
      setItem('confirmLeave', true)
    }

    function init() {
      loadStorageData()
      generalOptions.value = [
        {text: context.root.$t("MEETING.POPUP_ASK_TO_CONFIRM"), value: 'confirmLeave'},
      ]
      load()
    }

    function updateSetting(settingGroup) {
      settingGroup.forEach(
          value => {
            setItem(value.value, settings.value.includes(value.value))
          }
      )
    }

    async function load() {
      generalOptions.value.forEach(
          value => {
            if (getItem(value.value)) {
              if (!settings.value.includes(value.value)) {
                settings.value.push(value.value)
              }
            } else {
              settings.value = arrayRemove(settings.value, value.value)
            }
          }
      )
    }

    function arrayRemove(arr, value) { 
      return arr.filter(function(ele){ 
          return ele != value; 
      })
    }

    return {
      generalOptions,
      settings,
      updateSetting,
      init
    }
  }
}
</script>
<style>

.leave-meeting {
  min-height: 200px;
}

.leave-meeting-wrapper {
  max-width: 605px;
  padding: 0;
}

.leave-meeting .content {
  background-color: #ffffff;
  width: 100%;
  padding: 15px;
}

.leave-meeting .content .title {
  font-weight: 600;
  font-size: 16px;
  color: #282828;
  margin-bottom: 8px;
}

.leave-meeting .content .description {
  font-weight: 400;
  font-size: 14px;
  color: #282828;
  margin-bottom: 34px;
}

.leave-meeting .custom-checkbox label {
  font-size: 14px;
}
.leave-meeting label{
  font-size: 14px;
  font-weight: 400;
  color:#000000;
}

.testLink{
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color:#2166B2;
}
.pushedDown{
  margin-top: 32px;
}
.leave-meeting .volume{
  margin-top: 4px;
  display: flex;
}
.leave-meeting-body {
  min-height: 200px;
  background-color: #363636;
  padding: 0;
  border-radius: .25rem !important;
}

.rounded-top-left {
  border-top-left-radius: .25rem
}
@media (min-width: 768px) {
  .leave-meeting .content {
    padding: 32px 41px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LeaveMeeting.vue